export default {
  header: 'Add company to user'
}



// WEBPACK FOOTER //
// ./src/i18n/en/routes/addCompany.js